$shm_hitalama_app_fullscreen $mol_view
	map_book $shm_hitalama_map_book
	overlay_panel $shm_hitalama_app_overlay
	auto /
		<= fullscreen_widget_toggle_auto null
	sub /
		<= Group_scroll $mol_view
			event *
				scroll? <=> group_scroll? null
			sub /
				<= Group_space $mol_view
		<= Group_back $mol_view
		<= Group_fill $mol_view
		^ fullscreens /
	style *
		^
		display <= display \none
